import React from "react";
import {
  PhoneOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import { ConfigProvider, FloatButton } from "antd";

const FlotingIcon = () => {
  return (
    <>
      <FloatButton.Group
        shape="circle"
        style={{
          insetInlineEnd: 24,
        }}
      >
        <ConfigProvider
          theme={{
            token: {
              /* here is your global tokens */
              colorBgElevated: "#25D366",
            },
          }}
        >
          <FloatButton
            icon={<WhatsAppOutlined className="text-white" />}
            href="https://wa.me/+919326713857"
            target="_blank"
            style={{ backgroundColor: "#25D366" }}
          />
        </ConfigProvider>

        <FloatButton icon={<PhoneOutlined />} href="tel:+919326713857" />
        <FloatButton.BackTop />
      </FloatButton.Group>
    </>
  );
};

export default FlotingIcon;
